import React from 'react';
import MuButton from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import styles from '../../constants/styles';

export const Button = ({
  accent,
  classes,
  disabled,
  label,
  children,
  onClick,
  primary,
  type,
  isLoading
}) => {
  const color = primary 
    ? 'primary' 
    : accent 
      ? 'accent' 
      : 'default';

  return (
    <MuButton 
      variant="raised"
      color={color}
      disabled={disabled}
      className={classes.button}
      onClick={onClick}
      type={type}
    >
      {isLoading && <CircularProgress size={24} />}
      {label || children}
    </MuButton>
  );
};

Button.defaultProps = {
  type: 'button',
  accent: false,
  disabled: false,
  primary: false,
  label: undefined,
  onClick: undefined,
  isLoading: undefined,
  children: undefined,
}

Button.propTypes = {
  accent:   PropTypes.bool,
  type:     PropTypes.oneOf(['button', 'submit']),
  classes:  PropTypes.shape({
    button: PropTypes.string
  }).isRequired,
  disabled: PropTypes.bool,
  label:    PropTypes.string,
  onClick:  PropTypes.func,
  primary:  PropTypes.bool,
  isLoading: PropTypes.bool,
  children:       PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default withStyles(styles)(Button);



// WEBPACK FOOTER //
// ./src/components/common/Button.js